import { useTranslation } from "react-i18next";
import { usePermissions } from "@/hooks/usePermissions";
import { MainNav } from "./MainNav";

export function Sidebar({ open }: { open: boolean }) {
  const { t } = useTranslation();
  const permissions = usePermissions();

  return (
    <aside
      id="nbs-sidebar"
      className={`nbs-sidebar nbs-topnav${open ? " nbs-sidebar--open" : ""}`}
      aria-label={t("shell.mainNav")}
      data-role={permissions.productLabel}
      data-testid="app-sidebar"
      data-tour="nav-sidebar"
    >
      <MainNav
        className="nbs-sidebar__nav nbs-topnav__nav nbs-mainnav"
        listClassName="nbs-sidebar__list nbs-topnav__list nbs-mainnav__list"
        linkClassName="nbs-sidebar__link nbs-topnav__link nbs-mainnav__link"
        activeClassName="nbs-sidebar__link--active nbs-topnav__link--active nbs-mainnav__link--active"
      />
    </aside>
  );
}
